import React from 'react';
import { useDispatch } from 'react-redux';
import { hideNavMenu } from '../../../../actions/UI';

import {
  Container,
  CoreLink,
} from '../../../../components';

import './style.scss';

const NavigationMainMenuSubComponent = ({ item, setActive }) => {
  const dispatch = useDispatch();

  const renderMenuRecursively = (newSubTree) => {
    const itemToMap = newSubTree || item;
    return itemToMap.get('subtree').map((subItem) => {
      const subItemHref = subItem.getIn(['link', 'url']);
      const subItemTitle = subItem.getIn(['link', 'title'], '');
      return (
        <div className={`${newSubTree ? '' : ''}`} key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
          <li className={`NavigationMainMenuDesktop--subMenu__item ${newSubTree ? '' : 'NavigationMainMenuDesktop--subMenu__item--large'}`}>

            <CoreLink
              onClick={() => { dispatch(hideNavMenu()); setActive(false); }}
              className={`NavigationMainMenuDesktop--subMenu__items__title overlapping-link ${newSubTree ? '' : 'NavigationMainMenuDesktop--subMenu__items__title--large'}`}
              to={subItemHref}
            >
              {subItemTitle}
            </CoreLink>
          </li>
          {subItem.get('subtree').size > 0 && (
            renderMenuRecursively(subItem)
          )}
        </div>
      );
    });
  };

  return (
    <ul className="NavigationMainMenuDesktop--subMenu">
      <div className="NavigationMainMenuDesktop--subMenu__items">
        {renderMenuRecursively()}
      </div>
    </ul>
  );
};

export default NavigationMainMenuSubComponent;
